// 登入用户信息
export const userLogin = (state, data) => {
    state.userInfo = data

};
// 退出登录
export const outInfo = (state) => {
    localStorage.removeItem('token')
    state.userInfo = null
    // 清空cookie
    var date = new Date()
    date.setTime(date.getTime() - 10000);
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
        for (var i = keys.length; i--;)
            document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
    }
    window.location.reload()
};
// 汇率
export const getExchangeRate = (state, data) => {
    state.exchangeRate = data
};
// 更换头像
export const changePicture = (state, data) => {
    state.userInfo.data.pic = data
    console.log(data);
};
// 获取代购商品数量
export const daigouTotal = (state, num) => {
    state.daigouNum = num
};
// 购物车数量
export const shoppingTotal = (state, num) => {
    state.cartCount = num
};
// 登录跳转
export const toPage = (state, name) => {
    state.toPageName = name;
}
// 图片搜索结果
export const imgSearch = (state, data) => {
    state.imgData = data;
}
export const isLoading = (state, data) => {
    state.loading = data
}
